import { pushContract } from './push.contract';

// Individual re-exports (for route files importing specific contracts)
export { pushContract } from './push.contract';

// Aggregated export for service client creation
export const channelMessengerContracts = {
	pushContract,
};
